import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useIdleTimer } from 'react-idle-timer'
import { useHistory } from "react-router-dom";
import { logoutUser } from "../Pages/AdminPages/utils";
import { RootStateOrAny, useSelector } from "react-redux";

export default function Timeout (props) {
   const checkingPages = window.location.href.includes('adminLogin') ||
  window.location.href.includes('mtoken') ||
  window.location.href.includes('adminToken') ||
  window.location.pathname === '/'

  const userName = useSelector((state: RootStateOrAny) => state?.token?.userToken?.userName);

  const handleOnIdle = () => {
    if(checkingPages){
      return
    }
    toast.warning('logged out due to inactivity')
       setTimeout(() => {
        logoutUser(userName)
      }, 2000)
  }
  const handleOnActive = event => {
    console.log('')
    console.log('')
  }

  const handleOnAction = event => {
    console.log('')
  }

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: 1000 * 60 * 3,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    debounce: 500
  })

  return (
    <div>
      <ToastContainer position="top-center" autoClose={2000} />
    </div>
  )
}
